import React from 'react';

const StepFourSchedule = ({ data, onChange, errors }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
    
    // Clear error when user starts typing
    if (errors[name]) {
      errors[name] = '';
    }
  };

  // Get tomorrow's date as minimum date
  const getMinDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  // Generate time slots
  const timeSlots = [
    '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
    '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM', '06:00 PM'
  ];

  return (
    <div className="space-y-6">
      {/* Preferred Date */}
      <div>
        <label htmlFor="preferredDate" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
          Preferred Date *
        </label>
        <input
          type="date"
          id="preferredDate"
          name="preferredDate"
          value={data.preferredDate}
          onChange={handleInputChange}
          min={getMinDate()}
          className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
            errors.preferredDate ? 'border-red-500' : 'border-stone-300'
          }`}
          style={{focusRingColor: '#C8A96A'}}
        />
        {errors.preferredDate && (
          <p className="mt-1 text-sm text-red-500">{errors.preferredDate}</p>
        )}
        <p className="mt-1 text-sm text-stone-500">Select a date at least 24 hours from now</p>
      </div>

      {/* Preferred Time Slot */}
      <div>
        <label className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
          Preferred Time Slot *
        </label>
        <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
          {timeSlots.map((time) => (
            <button
              key={time}
              type="button"
              onClick={() => onChange({ preferredTime: time })}
              className={`py-2 px-3 rounded-lg border text-sm font-medium transition-all duration-300 ${
                data.preferredTime === time
                  ? 'border-primary text-white'
                  : 'border-stone-300 text-stone-700 hover:border-stone-400'
              }`}
              style={{
                backgroundColor: data.preferredTime === time ? '#C8A96A' : 'transparent'
              }}
            >
              {time}
            </button>
          ))}
        </div>
        {errors.preferredTime && (
          <p className="mt-1 text-sm text-red-500">{errors.preferredTime}</p>
        )}
      </div>

      {/* Schedule Info */}
      <div className="p-4 rounded-lg" style={{backgroundColor: '#F5EFE6'}}>
        <div className="flex items-start gap-3">
          <span className="material-symbols-outlined text-lg mt-1" style={{color: '#C8A96A'}}>
            schedule
          </span>
          <div>
            <h4 className="font-medium mb-1" style={{color: '#3E3E3E'}}>Consultation Schedule</h4>
            <p className="text-sm text-stone-600 mb-2">
              Our consultation slots are available from 9:00 AM to 6:00 PM, Monday to Saturday.
            </p>
            <div className="text-sm text-stone-600">
              <p className="mb-1">• Duration: 30-45 minutes</p>
              <p className="mb-1">• Format: In-person or video call</p>
              <p>• Confirmation: You'll receive a confirmation call</p>
            </div>
          </div>
        </div>
      </div>

      {/* Available Days */}
      <div>
        <h3 className="text-lg font-medium mb-3" style={{color: '#3E3E3E'}}>Available Days</h3>
        <div className="grid grid-cols-7 gap-2">
          {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
            <div
              key={day}
              className={`p-2 text-center rounded-lg text-sm font-medium ${
                index < 6
                  ? 'border border-stone-300 text-stone-700'
                  : 'bg-stone-100 text-stone-400'
              }`}
            >
              {day}
              {index < 6 && (
                <div className="text-xs text-green-600 mt-1">Available</div>
              )}
              {index === 6 && (
                <div className="text-xs text-stone-400 mt-1">Closed</div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Emergency Consultation */}
      <div className="p-4 rounded-lg border border-stone-200">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-medium" style={{color: '#3E3E3E'}}>Need urgent consultation?</h4>
            <p className="text-sm text-stone-600">Call us for immediate assistance</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined" style={{color: '#C8A96A'}}>
              phone
            </span>
            <span className="font-medium" style={{color: '#C8A96A'}}>+91 98765 43210</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepFourSchedule;
